import gql from 'graphql-tag'
import { get } from 'lodash'
import { IPathway as INormPathway } from '../../../types/Pathway'
import { apolloClientPrivate } from '../graphql/apolloClient'

export interface IPathway extends Pick<INormPathway, 'id'> {
  pathwayVersions: {
    id: number
  }
}
// TODO move into a gql file and use the generated query
export default async (
  pathwayId: number,
  topicIds: number[]
): Promise<IPathway> => {
  const mutation = gql`
    mutation pathwaySetTopics(
      $pathwayId: PositiveInt!
      $topicIds: [PositiveInt!]!
    ) {
      admin {
        pathway(id: $pathwayId) {
          id
          setTopics(topicIds: $topicIds) {
            id
            pathwayVersions {
              id
            }
          }
        }
      }
    }
  `

  const response = await apolloClientPrivate.mutate({
    variables: {
      topicIds,
      pathwayId
    },
    mutation
  })

  return get(response, 'data.admin.pathway.setTopics')
}
